import React, { Fragment, useEffect, useState, useMemo } from "react";
import { CCollapse, CLink } from "@coreui/react";
import axios from "axios";
import config from "../../config/config";

import { toastSuccess, toastError } from "../../common/Toast";
import { Noimage } from "../../common/imagePath";
//--------Material React Table------//

import { Box, Button, IconButton, MenuItem, Tooltip } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import DeleteConfirmationModalBanner from "../Modal/DeleteConfirmation";
import CommonMatrialReactTable from "../Datatable/CommonMatrialReactTable";

function TopBrands(props) {
  console.log(props, "check value");

  const [visibleTopBrand, setvisibleTopBrand] = useState(false);
  const token = localStorage.getItem("Token");

  const [brands, setbrands] = useState(props.visiblebrandsChange);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [data11, setdata11] = useState(true);

  // CALLBACK
  const [datas, setdata] = useState([]);

  const [dynamicValue, setDynamicValue] = useState("MainSite");

  useEffect(() => {
    if (props?.dynamicModule) {
      setDynamicValue(props.dynamicModule);
    }
  }, [props?.dynamicModule]);
  // const dynamicValue = props?.dynamicModule == "MainSite" ? 'CommonConfigValue' : props?.dynamicModule

  const fetchApi = () => {
    axios
      .get(
        `${config.ecommconfigBaseUrl}/ecomconfig/findbrands?from=${dynamicValue}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setdata(res.data.ResponseID);
        return res;
      });
  };

  //UseEffect For Table
  useEffect(() => {
    fetchApi();
  }, [dynamicValue]);

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
    },
    {
      header: "brands Name",
      accessorKey: "Name",
    },
    {
      header: "brands Image",

      Cell: ({ row }) => (
        <a target="_blank" href={row.original.Imagename}>
          <img
            src={row.original.Imagename ? row.original.Imagename : Noimage}
            style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
          />
        </a>
      ),
    },
  ]);

  const callback = (payload) => {
    // if (payload != undefined && payload != null && payload != "") {
    //   setfeaturedbrands(payload);
    // }
    fetchApi();
  };

  const openDeleteFunction = (row) => {
    const deleteRequestParam = {
      ID: row.original.ID,
      from : dynamicValue
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );

    setDeleteModalOpen(true);
  };

  const muiRowDragHandleProps = ({ table }) => ({
    onDragEnd: () => {
      const { draggingRow, hoveredRow } = table.getState();
      if (hoveredRow && draggingRow) {
        datas.splice(
          hoveredRow.index,
          0,
          datas.splice(draggingRow.index, 1)[0]
        );
        setdata([...datas]);
      }
    },
  });

  const handelSaveRowOrder = () => {
    const categoryIdList = datas.map((el) => el.ID).join(",");
    const finalData = {
      ids: categoryIdList,
      model: "Brand",
      type: "TopBrands",
    };

    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/setRowOrder`, finalData, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        toastSuccess("Brands Row Order Successfully Done");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // TableColumns

  return (
    <Fragment>
      <div className="card">
        <div className="card-header">
          <h5 className="card-title">
            <CLink
              className="link"
              onClick={() => {
                setvisibleTopBrand(!visibleTopBrand);
                setbrands(!!brands);
              }}
            >
              Top brands
            </CLink>
          </h5>
        </div>
        <CCollapse visible={visibleTopBrand || props.visiblebrandsChange}>
          <div className="card-body">
            <div className="row">
              <div className="col-6">
                <SearchableDropdown
                  callback={callback}
                  dynamicValue={dynamicValue}
                />
              </div>
              <div className="col-6 d-flex justify-content-end align-items-start">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => handelSaveRowOrder()}
                  style={{ margin: "6px" }}
                >
                  Save Row Order
                </button>
              </div>
            </div>
            <div
              className="table-responsive mt-4"
              style={{ border: "1px solid rgba(0,0,0,.12)" }}
            >
              <CommonMatrialReactTable
                columns={columns}
                data={datas}
                hodiExport={true}
                enableRowSelection={false}
                enableRowOrdering={true}
                muiRowDragHandleProps={muiRowDragHandleProps}
                enableRowActions={true}
                renderRowActions={({ row }) => (
                  <Box>
                    <IconButton onClick={() => openDeleteFunction(row)}>
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                )}
                // renderRowActionMenuItems={({ row }) => [
                //   <MenuItem
                //     className="confirm-text"
                //     to="#"
                //     // key="delete"
                //     title="Delete"
                //     data-bs-toggle="modal"
                //     // data-bs-target="#DeleteConfirmationModal"
                //     onClick={() => openDeleteFunction(row)}
                //   >
                //     <DeleteIcon />
                //     Delete
                //   </MenuItem>,
                // ]}
              />
            </div>
          </div>
        </CCollapse>
      </div>
      <DeleteConfirmationModalBanner
        deleteApiUrl={`${config.ecommconfigBaseUrl}/ecomconfig/deletebrands`}
        open={deleteModalOpen}
        data11={data11}
        onClose={() => {
          setDeleteModalOpen(false);
          fetchApi();
        }}
        dynamicValue={dynamicValue}
      />
    </Fragment>
  );
}

// SearchableDropdown
const SearchableDropdown = ({ callback, dynamicValue }) => {
  const token = localStorage.getItem("Token");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const fetchData = async (inputValue) => {
    if (inputValue !== "") {
      axios
        .get(`${config.brandBaseUrl}/brands?from=${dynamicValue}`, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        })
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;

            const filteredData = data.filter((Brand) =>
              Brand.Name.toLowerCase().includes(inputValue.toLowerCase())
            );
            if (filteredData.length > 0) {
              setSuggestions(filteredData);
            } else {
              setSuggestions([]);
            }
          }
        })
        .catch((error) => {});
    } else {
      setSuggestions([]);
    }
  };
  useEffect(() => {
    // Fetch data from an API
    fetchData(inputValue);
  }, [inputValue]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleInputClick = (
    // event,
    pbrandId,
    pbrandName,
    pbrandimage,
    dynamicValue
  ) => {
    const selectedOption = {
      ID: pbrandId,
      BrandName: pbrandName,
      Imagename: pbrandimage,
      dynamicValue: dynamicValue,
    };

    const brandsids = pbrandId;

    const data = {
      Topbrands: brandsids,
      From: dynamicValue,
    };

    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/topbrands`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        toastSuccess("Brands Add Successfully Done");
        callback(selectedOption);
        setInputValue("");
        setSuggestions([]);
      })
      .catch((error) => {
        // setLoading(false);
      });
  };

  return (
    <div className="container">
      <form>
        <div className="mb-3" style={{ width: "400px" }}>
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <i
                class="fa fa-edit fs-3"
                style={{ color: "var(--secondary-main-color)" }}
              ></i>
            </span>

            <input
              type="text"
              className="form-control h-auto"
              placeholder="Search Brand name"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div
            className="dropdown"
            style={{ position: "relative", width: "400px" }}
          >
            <ul
              className="dropdown-menu show dropdown-suggestion"
              style={{
                //  width: "100%",
                maxHeight: "400px",
                overflowY: "auto",
              }}
            >
              {suggestions.map((brand, index) => (
                <li
                  key={brand.brandId}
                  onClick={(e) =>
                    handleInputClick(
                      brand.ID,
                      brand.Name,
                      brand.ImageName,
                      dynamicValue
                    )
                  }
                  style={{ cursor: "pointer" }}
                  className={"dropdown-item"}
                >
                  <a
                    key={brand.ID}
                    data-name={brand.Name}
                    className={"dropdown-item"}
                  >
                    {/* <div className="d-flex align-items-center"> */}
                    <img
                      src={brand.Imagename ? brand.Imagename : Noimage}
                      alt="No Image!"
                      className="img-thumbnail m-3"
                      width="65px"
                      height="65px"
                    />
                    <div className="customer-info">
                      <h6 className="name word-break-data">{brand.Name}</h6>
                      <p>Brand Id : {brand.ID}</p>
                    </div>
                    {/* </div> */}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          inputValue && (
            <p
              style={{ height: "40px", width: "300px", padding: "10px" }}
              className="dropdown-menu show dropdown-suggestion"
            >
              Barnd Not Fount
            </p>
          )
        )}
      </form>
    </div>
  );
};
// SearchableDropdown

export default TopBrands;
